function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import * as languages from '../resources';

// Returns only the translations required for the specified namespaces
var getResources = function getResources(namespaces) {
  var requiredLanguages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var resources = namespaces.reduce(function (acc, namespace) {
    var availableLanguages = Object.keys(languages);
    availableLanguages.forEach(function (lang) {
      if (!Object.keys(languages[lang]).includes(namespace)) {
        throw new Error("No namespace '".concat(namespace, "'"));
      }
    });
    var targettedLanguages = requiredLanguages.length ? requiredLanguages : availableLanguages;
    targettedLanguages.forEach(function (lng) {
      var language = lng.split('-')[0];
      acc[language] = _objectSpread(_objectSpread({}, acc[language]), {}, _defineProperty({}, namespace, languages[language][namespace]));
      return acc[language];
    });
    return acc;
  }, {});
  return resources;
};
export default getResources;